export default __webpack_public_path__ + "static/business_321-2dd07fb0061bd1043be04194c378b8fb.jpg";